import { render, staticRenderFns } from "./AdminLedgerEntries.vue?vue&type=template&id=ad475ba6&"
import script from "./AdminLedgerEntries.vue?vue&type=script&lang=js&"
export * from "./AdminLedgerEntries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports